

export const DEFAULT_BACKGROUND_IMAGE =
    require('../Static/Images/background.jpeg')

export const DEFAULT_MOOD = 'default'
export const MOOD_BACKGROUND_IMAGES = {
  beloved: require('../Static/Images/t800-beloved.png'),
  happy: require('../Static/Images/t800-happy.png'),
  laughing: require('../Static/Images/t800-laughing.png'),
  sad: require('../Static/Images/t800-sad.png'),
  vulnerable: require('../Static/Images/t800-vulnerable.png'),
  [DEFAULT_MOOD]: DEFAULT_BACKGROUND_IMAGE,
}

const EMOJI_MOOD_GROUPS = [
  {
    mood: DEFAULT_MOOD,
    emojis: ['🤔', '🤨', '🧐', '😐', '😑', '🙄','🤷🏼‍♂️','🤷','🤷🏻‍♀️','👀'],
  },
  {
    mood: 'laughing',
    emojis: ['😂', '🤣', '😆', '😅', '😹', '😬'],
  },
  {
    mood: 'beloved',
    emojis: ['❤️', '♥️','❤', '🧡', '💛', '💚', '💙', '💜', '🤎', '🖤', '🤍', '💖', '💗', '💓', '💞', '💕', '💘', '💝', '💟', '😍', '🥰', '😘', '😻'],
  },
  {
    mood: 'happy',
    emojis: ['😀', '😃', '😄', '😁', '🙂', '😊', '☺️', '🤗', '😌', '😎', '🤩', '🥳', '🙌', '✨', '🌞','😜'],
  },
  {
    mood: 'sad',
    emojis: ['😢', '😭', '😞', '😔', '🙁', '☹️', '☹', '😟', '😕', '😣', '😖', '😫', '😩', '💔','😡','😒'],
  },
  {
    mood: 'vulnerable',
    emojis: ['🥺', '😳', '😶‍🌫️', '😶', '🫠', '😥', '😰', '😨', '😱', '😮‍💨',  '🫣'],
  },
]

export const getMoodFromText = (text = '') => {
  let lastMood = null
  let lastIndex = -1

  for (const group of EMOJI_MOOD_GROUPS) {
    for (const emoji of group.emojis) {
      const index = text.lastIndexOf(emoji)
      if (index > lastIndex) {
        lastIndex = index
        lastMood = group.mood
      }
    }
  }
  return lastMood
}

export const getLatestAssistantMood = (reflectedChatRaw) => {
  if (!reflectedChatRaw) return null

  for (let i = reflectedChatRaw.size - 1; i >= 0; i--) {
    const entry = reflectedChatRaw.get(i)
    if (entry.get('role') !== 'assistant') continue

    const mood = getMoodFromText(entry.get('text') || '')
    if (mood) return mood
  }

  return null
}
